<template>
  <v-form lazy-validation v-model="valid" ref="Form">
    <v-container class="text-center">
      <v-text-field
          label="Nazwa"
          type="Text"
          :min="0"
          :counter="32"
          v-model="name"
          :rules="nameRule"
      ></v-text-field>
      <v-text-field
          label="Opis"
          type="Text"
          :min="0"
          :counter="255"
          v-model="description"
          :rules="descriptionRule"
      ></v-text-field>
      <v-select
          v-model="type"
          hint="Wybierz typ magazynu"
          :items="types"
          item-text="name"
          item-value="id"
          label="Typ magazynu"
          persistent-hint
          return-object
          single-line
      ></v-select>
      <v-text-field
          label="Ilość"
          type="Number"
          :min="0"
          :max="2147483648"
          v-model="quantity"
          :rules="quantityRule"
      ></v-text-field>
      <v-btn @click="$emit('submited', { name,description, quantity, type, valid })" color="green">
        Dodaj
      </v-btn>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "ItemForm",
  props:['updateItem','types'],
  data: () => ({
    valid: true,
    name: '',
    description: '',
    type: null,
    quantity: '',
    nameRule: [v => !!v || "name is required", v => v.length <= 32 || "Max 32 characters",  ],
    descriptionRule: [v => !!v || "description is required", v => v.length <= 255 || "Max 55 characters",  ],
    quantityRule: [v => !!v || "Pole nie może być puste", v => !!v || !Number.isInteger(v) || Number.isInteger(Math.floor(v)) || "Wprowadź poprawną ilość",  ],
  }),
  watch:{
    updateItem:function (newVal){
      this.name = newVal.name
      this.description = newVal.description
      this.quantity = newVal.quantity
      this.type = newVal.storage_type ? newVal.storage_type.id : null
    }
  },
}
</script>

<style scoped>

</style>